export default {
  // Navigation
  'nav.home': 'Inicio',
  'nav.solutions': 'Soluciones',
  'nav.features': 'Características',
  'nav.pricing': 'Precios',
  'nav.login': 'Iniciar Sesión',
  'nav.getStarted': 'Comenzar',
  
  // Hero Section
  'hero.title': 'Plataforma Global de Aceleración de Juegos',
  'hero.subtitle': 'Soluciones de Red Integrales para Editores de Juegos en el Extranjero',
  'hero.description': 'Aprovechando redes de aceleración multinodo, programación dinámica de tráfico y protección de seguridad de espectro completo para ofrecer servicios de red integrados de Descarga-Interacción-Protección',
  'hero.cta.primary': 'Iniciar Prueba Gratuita',
  'hero.cta.secondary': 'Ver Demo',
  
  // Stats
  'stats.latency': 'Reducción Promedio de Latencia',
  'stats.conversion': 'Aumento de Conversión de Instalación',
  'stats.uptime': 'Tiempo de Actividad del Servicio',
  'stats.nodes': 'Nodos de Aceleración Global',
  
  // Solutions
  'solutions.title': 'Soluciones Integrales',
  'solutions.subtitle': 'Abordando Tres Puntos Críticos en las Operaciones de Juegos Globales',
  
  'solutions.download.title': 'Aceleración Inteligente de Descargas',
  'solutions.download.desc': 'Red CDN multinodo que garantiza descargas estables de paquetes de juegos en mercados emergentes, aumentando las tasas de conversión de instalación en un 18%',
  'solutions.download.feature1': 'Tecnología de Reanudación de Punto de Interrupción',
  'solutions.download.feature2': 'Selección Inteligente de Rutas',
  'solutions.download.feature3': 'Descarga Multi-fuente',
  
  'solutions.interaction.title': 'Interacción de Baja Latencia',
  'solutions.interaction.desc': 'Optimización de latencia a nivel de milisegundos para batallas entre servidores y torneos globales, mejorando la experiencia de juego competitivo',
  'solutions.interaction.feature1': 'Programación Dinámica de Tráfico',
  'solutions.interaction.feature2': 'Optimización de Protocolo',
  'solutions.interaction.feature3': 'Monitoreo en Tiempo Real',
  
  'solutions.security.title': 'Protección de Seguridad Integral',
  'solutions.security.desc': 'Mecanismos avanzados de defensa contra ataques DDoS y CC, garantizando una disponibilidad del servidor del 99.99%',
  'solutions.security.feature1': 'Detección Inteligente de Amenazas',
  'solutions.security.feature2': 'Sistema de Defensa Multicapa',
  'solutions.security.feature3': 'Monitoreo de Seguridad 24/7',
  
  // Features
  'features.title': 'Características de la Plataforma',
  'features.subtitle': 'Capacidades Poderosas que Impulsan tu Éxito en Juegos Globales',
  
  'features.network.title': 'Red de Aceleración Global',
  'features.network.desc': 'Más de 500 nodos en 6 continentes, cubriendo todos los principales mercados de juegos',
  
  'features.analytics.title': 'Panel de Análisis en Tiempo Real',
  'features.analytics.desc': 'Información completa de datos para el rendimiento de la red y la experiencia del usuario',
  
  'features.api.title': 'API Amigable para Desarrolladores',
  'features.api.desc': 'Fácil integración con API RESTful y documentación completa',
  
  'features.support.title': 'Soporte Técnico 24/7',
  'features.support.desc': 'Equipo de soporte dedicado disponible las 24 horas',
  
  'features.scalability.title': 'Infraestructura de Escalado Automático',
  'features.scalability.desc': 'Ajusta automáticamente los recursos según las demandas de tráfico',
  
  'features.compliance.title': 'Cumplimiento Global',
  'features.compliance.desc': 'Cumple con las regulaciones de protección de datos en diferentes regiones',
  
  // Pricing
  'pricing.title': 'Planes de Precios Flexibles',
  'pricing.subtitle': 'Elige el Plan Perfecto para tu Negocio de Juegos',
  
  'pricing.starter.name': 'Inicial',
  'pricing.starter.price': '$299',
  'pricing.starter.period': '/mes',
  'pricing.starter.desc': 'Perfecto para desarrolladores de juegos independientes',
  'pricing.starter.feature1': 'Hasta 100GB de ancho de banda',
  'pricing.starter.feature2': '50 nodos de aceleración',
  'pricing.starter.feature3': 'Protección DDoS básica',
  'pricing.starter.feature4': 'Soporte por correo electrónico',
  'pricing.starter.feature5': 'Acceso a API',
  
  'pricing.professional.name': 'Profesional',
  'pricing.professional.price': '$999',
  'pricing.professional.period': '/mes',
  'pricing.professional.desc': 'Ideal para estudios de juegos en crecimiento',
  'pricing.professional.feature1': 'Hasta 1TB de ancho de banda',
  'pricing.professional.feature2': '200 nodos de aceleración',
  'pricing.professional.feature3': 'Protección DDoS avanzada',
  'pricing.professional.feature4': 'Soporte prioritario',
  'pricing.professional.feature5': 'Análisis personalizados',
  'pricing.professional.feature6': 'Gerente de cuenta dedicado',
  
  'pricing.enterprise.name': 'Empresarial',
  'pricing.enterprise.price': 'Personalizado',
  'pricing.enterprise.period': '',
  'pricing.enterprise.desc': 'Para editores de juegos a gran escala',
  'pricing.enterprise.feature1': 'Ancho de banda ilimitado',
  'pricing.enterprise.feature2': 'Más de 500 nodos de aceleración',
  'pricing.enterprise.feature3': 'Seguridad de nivel empresarial',
  'pricing.enterprise.feature4': 'Soporte dedicado 24/7',
  'pricing.enterprise.feature5': 'Integración personalizada',
  'pricing.enterprise.feature6': 'Garantía SLA',
  'pricing.enterprise.feature7': 'Solución de marca blanca',
  
  'pricing.cta': 'Elegir Plan',
  'pricing.popular': 'Más Popular',
  
  // CTA Section
  'cta.title': '¿Listo para Acelerar tu Éxito en Juegos Globales?',
  'cta.description': 'Únete a cientos de editores de juegos en todo el mundo que confían en Elephant Tech para su infraestructura de red',
  'cta.button': 'Inicia tu Prueba Gratuita',
  
  // Footer
  'footer.product': 'Producto',
  'footer.solutions': 'Soluciones',
  'footer.features': 'Características',
  'footer.pricing': 'Precios',
  'footer.documentation': 'Documentación',
  
  'footer.company': 'Empresa',
  'footer.about': 'Sobre Nosotros',
  'footer.careers': 'Carreras',
  'footer.blog': 'Blog',
  'footer.press': 'Prensa',
  
  'footer.resources': 'Recursos',
  'footer.help': 'Centro de Ayuda',
  'footer.api': 'Referencia API',
  'footer.status': 'Estado del Sistema',
  'footer.security': 'Seguridad',
  
  'footer.legal': 'Legal',
  'footer.privacy': 'Política de Privacidad',
  'footer.terms': 'Términos de Servicio',
  'footer.compliance': 'Cumplimiento',
  
  'footer.copyright': '© 2024 Elephant Tech Limited. Todos los derechos reservados.',
  'footer.poweredBy': 'Desarrollado por Readdy',
  
  // Login Page
  'login.title': 'Inicio de Sesión Empresarial',
  'login.subtitle': 'Accede a tu plataforma de aceleración de juegos',
  'login.selectedPlan': 'Plan Seleccionado',
  'login.email': 'Correo Electrónico',
  'login.password': 'Contraseña',
  'login.remember': 'Recordarme',
  'login.forgot': '¿Olvidaste tu contraseña?',
  'login.submit': 'Iniciar Sesión',
  'login.noAccount': '¿No tienes una cuenta?',
  'login.contact': 'Contactar Ventas',
  'login.or': 'O continuar con',
  'login.google': 'Google',
  'login.microsoft': 'Microsoft',
};
